<template>
  <div>
    <div class="p-4 md:p-10 lg:p-12 pt-8 lg-pr-header">
      <base-headline class="text-3xl mb-3">{{ $t('general', 'current') }}</base-headline>

      <ul>
        <li v-for="item in current" :key="item.uri" class="border-t border-black">
          <now-row-item :item="item"/>
        </li>
        <li class="border-t border-black">
          <router-link :to="localeLink('/program')">
            <p class="py-5 text-2xl lg:text-3xl">{{ $t('general', 'more') }}</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NowRowItem from '@/components/NowRowItem'

export default {
  name: 'NowBlock',
  computed: {
    current () {
      return this.localeList(this.$store.state.current)
    }
  },
  components: { NowRowItem }
}
</script>
